// src/components/CustomToast.js
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const notify = (type, message) => {
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  }
};

const CustomToast = () => {
  return <ToastContainer position="top-right" autoClose={3000} />;
};

export default CustomToast;
